import React, {useContext, useState} from "react"
import PropTypes from "prop-types";
import Loading from "components/Loading";
import FormTranslationContext from "context/FormTranslationContext";
import {Table, TableBody, TableHead, TableRow, Tooltip} from "@material-ui/core";
import AnnualReportTableCell from "../common/AnnualReportTableCell";
import Tr from "translations/Translations";
import AnnualReportEditPopup from "../common/AnnualReportEditPopup";
import AnnualReportAboveEuEditForm from "./AnnualReportAboveEuEditForm";
import annualReportSteps from "../../constants/annualReportSteps";
import formatAmountNumber from "libs/formatAmountNumber";
import formatBoolean from "libs/formatBoolean";
import formatInteger from "libs/formatInteger";
import AnnualReportSearchBar from "../common/AnnualReportSearchBar";
import AnnualReportTableHeadCell from "../common/AnnualReportTableHeadCell";
import AnnualReportTablePart from "../common/AnnualReportTablePart";
import MoveAnnualReportEntry from "../common/MoveAnnualReportEntry";

const columns = ["number", "noticeNumber", "orderType", "codeCPV", "tenderMode", "contractorCountryList", "contractValue", "numberOfAwardedLots",
    "numberOfOffers", "numberOfRejectedOffers", "numberOfOffersSubmittedByMMSP", "contractAwardedToMMSP"];
const reportStep = annualReportSteps.aboveEu;

function AnnualReportAboveEuForm(
    {
        initValues,
        classes,
        disabled
    }
) {
    const {getDict, dictTranslations} = useContext(FormTranslationContext);
    const [types] = useState(getDict("MP.MMiA.OrdersType"));
    const [editPopup, setEditPopup] = useState(null);
    const [movePopup, setMovePopup] = useState(null);
    const [search, setSearch] = useState({search: ""});

    const getRowValues = (entry) => ([
        entry.number,
        entry.noticeNumber,
        entry.orderType ? dictTranslations.orderType[entry.orderType] : null,
        entry.codeCPV ? <Tooltip title={entry.codeCPV.name}><span>{entry.codeCPV.publicCode}</span></Tooltip> : null,
        entry.tenderMode ? dictTranslations.tenderModeTed[entry.tenderMode] : null,
        entry.contractorCountryList ? entry.contractorCountryList.join(", ") : null,
        formatAmountNumber(entry.contractValue),
        formatInteger(entry.numberOfAwardedLots),
        formatInteger(entry.numberOfOffers),
        formatInteger(entry.numberOfRejectedOffers),
        formatInteger(entry.numberOfOffersSubmittedByMMSP),
        formatBoolean(entry.contractAwardedToMMSP)
    ])

    if (!initValues) return <Loading/>
    return <>
        <AnnualReportSearchBar reportStep={reportStep} setSearch={setSearch} classes={classes} disabled={disabled} setEditPopup={setEditPopup}/>

        <Table>
            <TableHead>
                <TableRow className={classes.tableMainHeaderRow}>
                    {columns.map(x => (<AnnualReportTableHeadCell key={x} label={`mmia.${reportStep}.${x}`}/>))}
                    <AnnualReportTableCell borderLeft borderRight colSpan={2}></AnnualReportTableCell>
                </TableRow>
            </TableHead>
            <TableBody>
                {
                    types.map((type) =>
                        <AnnualReportTablePart
                            key={type.value}
                            classes={classes}
                            type={type.value}
                            reportStep={reportStep}
                            partName={dictTranslations.type[type.value]}
                            disabled={disabled}
                            entries={initValues[type.value]}
                            search={search}
                            setEditPopup={setEditPopup}
                            setMovePopup={setMovePopup}
                            columnCount={columns.length}
                            getRowValues={getRowValues}
                        />
                    )
                }
            </TableBody>

        </Table>

        {
            !!editPopup &&
            <AnnualReportEditPopup
                onClose={() => setEditPopup(null)}
                config={editPopup}
                reportStep={annualReportSteps.aboveEu}
                FormComponent={AnnualReportAboveEuEditForm}
            />
        }
        {
            !!movePopup &&
            <MoveAnnualReportEntry
                items={types.filter((item) => item.value !== movePopup.currentType)}
                onClose={() => setMovePopup(null)}
                inputLabel={Tr("order_type")}
                reportStep={reportStep}
                config={movePopup}
            />
        }
    </>


}

AnnualReportAboveEuForm.prototype = {
    initValues: PropTypes.object.isRequired,
    disabled: PropTypes.bool.isRequired,
    classes: PropTypes.object.isRequired
}

export default AnnualReportAboveEuForm;